import url from "url/index";
import { useMutation } from "@tanstack/react-query";
import { api } from "../stores/api/api";
import { getAuthToken } from "../helpers/authToken";

interface PromoCodeResponse {
  message: string;
}

interface PromoCodeRequest {
  code: string;
}

interface ApiError {
  errorCode: string;
  statusCode?: number;
}

export const usePromoCode = (options?: {
  onSuccess?: (data: PromoCodeResponse) => void;
  onError?: (error: ApiError) => void;
}) => {
  return useMutation<PromoCodeResponse, ApiError, PromoCodeRequest>({
    mutationKey: ["apply-promo-code"],
    mutationFn: async (data: PromoCodeRequest) => {
      try {
        const response = await api.post(
          url.config.api.bonuses.promocode,
          data,
          {
            headers: getAuthToken(),
          },
        );
        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data) {
          const apiError: ApiError = {
            errorCode: error.response.data.errorCode || "UNKNOWN_ERROR",
          };
          throw apiError;
        }
        const apiError: ApiError = {
          errorCode: "UNEXPECTED_ERROR",
        };
        throw apiError;
      }
    },
    ...options,
  });
};
